export * from './TableFooter.styled';
